import * as Styled from '../styled';

function LinkError() {
  return (
    <Styled.Wrapper role="region">
      <Styled.Title>Não foi possível validar esse link</Styled.Title>
      <Styled.Description variant="sub300">
        Tente solicitar um novo link para continuar.
      </Styled.Description>
    </Styled.Wrapper>
  );
}

export default LinkError;
